import { SVGProps } from "react";
export default function CategoryIcon({ ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 30 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y="0.5" width="30" height="1" fill="#18212D" />
      <rect y="10.5" width="30" height="1" fill="#18212D" />
      <rect y="20.5" width="30" height="1" fill="#18212D" />
    </svg>
  );
}
